module.exports = __webpack_public_path__ + "img/cert39.8ec13ed7.jpg";